import { useQuery } from 'react-query';
import { Project } from 'mdello-client-ts/dist/src/interfaces/common/project.interface';
import { Paginated } from 'mdello-client-ts/dist/src/interfaces/common/paging.interface';
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum';
import { useNotification } from 'src/providers/notificationsProvider';
import { getDataFromLocalStorage } from 'src/localStorage/getDataFromLocalStorage';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';
import { getOrdersGroup } from 'src/services/napi/ordersGroup/fetchOrdersGroup';
import { OrderGroupDetailed } from './interfaces/orderGroup.interface';

const fetchOrdersGroup = async (params: {
  orderDirection?: string;
  page?: string;
  pageSize?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
}): Promise<{ data: OrderGroupDetailed[]; paging: Paginated } | undefined> => {
  const { sortBy, page, pageSize, search, sortOrder } = params;

  const currentProject: Project | undefined = getDataFromLocalStorage(
    LocalStorageKey.CURRENT_PROJECT
  );

  if (!currentProject) return;
  const data: any | undefined = await getOrdersGroup({
    page: page || '1',
    pageSize: pageSize || '10',
    projectId: currentProject._id,
    search: search || '',
    sortBy: sortBy || 'createdAt',
    sortOrder: sortOrder || '-1'
  });

  if (!data) return;

  return { data: data.data, paging: data.paging };
};

export const useGetOrdersGroup = (params: {
  page?: string;
  pageSize?: string;
  search?: string;
  sortBy?: string;
  sortOrder?: string;
}) => {
  const { notify } = useNotification();
  const { sortBy, page, pageSize, search, sortOrder } = params;

  return useQuery(
    [QueryKey.ORDER_GROUP, page, pageSize, sortBy, search, sortOrder],
    () =>
      fetchOrdersGroup({
        page,
        pageSize,
        search,
        sortBy,
        sortOrder
      }),
    {
      onError: () => {
        notify({ message: 'Error Loading data... Try again later', severity: 'error' });
      }
    }
  );
};
